import { render, staticRenderFns } from "./mobile_detail.vue?vue&type=template&id=59d32ea8"
import script from "./mobile_detail.vue?vue&type=script&lang=js"
export * from "./mobile_detail.vue?vue&type=script&lang=js"
import style0 from "./mobile_detail.vue?vue&type=style&index=0&id=59d32ea8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports